import { useState } from 'react';
import background from '../assets/images/blue.png';
import dots from '../assets/images/dots.png';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import useTitle from '../Hooks/useTitle';
// Import your forgot password action
import { forgotPassword } from '../Redux/Action/AuthAction'; 

const ForgotPassword = () => {
    useTitle('Forgot Password');
    const { t } = useTranslation('forgotpassword');
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.Auth);

    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email) {
            toast.error(t("error_empty"));
            return;
        }
        if (!email.match(validRegex)) {
            toast.error(t("error_invalid"));
            return;
        }

        dispatch(forgotPassword({ email }))
            .then(() => {
                toast.success(t("success_message"));
                    setEmail(""); // Clear input

            })
            .catch((error) => {
                toast.error(Object.values(error.response?.data?.errors || {})[0]?.[0] || t("error_generic"));
            });

    }

    return (
        <div className="flex w-[100vw] h-[100vh]">
            <div className="hidden w-[35vw] h-[100vh] relative sm:hidden lg:block">
                <img src={background} alt="background" className='h-[100vh] w-full object-cover' />
                <div className='absolute top-10 right-[10%]'>
                    <img src={dots} alt="dots" />
                </div>

                <div className="absolute lg:top-[30%] xl:top-[35%] text-center grid gap-5 flex flex-col justify-items-center w-full xl:p-[50px] md:p-[30px]">
                    <div className="">
                        <h1 className='font-[600] text-[40px] text-white'>{t('main_title')}</h1>
                        <div className="bg-[white] rounded-md w-[50px] h-[3px] mx-auto mt-2"></div>
                    </div>
                    <p className='text-white font-[300] text-[15px]'>{t("description")}</p>
                    <Link to="/" className='text-[#3686ff] bg-white max-w-32 w-full h-[52px] rounded-[15px] mx-auto text-center flex items-center justify-center'>{t("signin_button")}</Link>
                </div>

                <div className='absolute bottom-10 left-[10%]'>
                    <img src={dots} alt="dots" />
                </div>
            </div>

            <div className="w-full min-h-screen flex justify-center items-center bg-[#EDF4FF]">
                <div className="w-full mx-auto bg-[#EDF4FF] px-[30px] py-[40px] lg:w-[65vw]">
                    {
                        loading ? (
                            <div className="w-full h-[100vh] flex justify-center items-center">
                                <CircularProgress size="3rem" />
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit} className="bg-white p-[20px] sm:p-[40px] rounded-[20px] w-full mt-[300px] sm:mt-0">
                                <div className='grid gap-[32px]'>
                                    <div className="text-center w-full">
                                        <h1 className='font-[700] text-[#131415] text-[26px]'>{t("title")}</h1>
                                        <p className='text-[#535861]'>{t("subtitle")}</p>
                                    </div>
                                    <div className="flex flex-col gap-2 w-full sm:w-[80%] mx-auto">
                                        <span className='text-[14px] font-[500] text-[#131415] text-left'>{t("email_label")}</span>
                                        <input
                                            type="text"
                                            placeholder={t("email_placeholder")}
                                            className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-2 text-[14px] w-full'
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                    <button type="submit" className='bg-[#3686ff] text-white max-w-32 w-full h-[52px] rounded-[15px] mx-auto text-center flex items-center justify-center'>
                                        {t("submit_button")}
                                    </button>
                                </div>
                            </form>
                        )
                    }
                    <p className="text-center text-sm text-[#535861] mt-4 w-full lg:hidden">{t("remembered")} <Link to="/" className="text-[#3686ff] font-medium">{t("signin_button")}</Link></p>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword
